import React, { useEffect, useRef } from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import FixedActionsBar from '@/components/FixedActionsBar/FixedActionsBar';

import styles from './styles.module.css';

interface QpsIntroductionProps {
  questionCount: number;
  productName: string;
  productIsin: string;
  introDescription?: string | null;
  questionnaireIndex?: number;
  questionnaireCount?: number;
  onStart: () => void;
  onExit: () => void;
}

const QpsIntroduction: React.FC<QpsIntroductionProps> = ({
  questionCount,
  productName,
  productIsin,
  introDescription,
  questionnaireIndex,
  questionnaireCount,
  onStart,
  onExit,
}) => {
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement>(null);
  const isMultiQuestionnaire = questionnaireCount !== undefined && questionnaireCount > 1;

  // L'introduction remplace le récapitulatif (ou la 1re question au retour) sans changer de route :
  // sans ce recentrage, rien n'est annoncé et le focus reste sur le bouton démonté.
  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <div className={styles.screen}>
      <header className={styles.header}>
        <p className={styles.overline}>
          {isMultiQuestionnaire
            ? t('qps.intro.overlineMulti', {
                count: questionCount,
                index: questionnaireIndex,
                total: questionnaireCount,
              })
            : t('qps.intro.overline', { count: questionCount })}
        </p>
        <h1 className={styles.title} ref={titleRef} tabIndex={-1}>
          {t('qps.intro.title')}
        </h1>
        <p className={styles.subtitle}>{t('qps.intro.subtitle')}</p>
      </header>

      <section className={styles.productCard}>
        <p className={styles.productName}>{productName}</p>
        <p className={styles.productIsin}>{t('qps.intro.isin', { isin: productIsin })}</p>
      </section>

      {introDescription && <p className={styles.description}>{introDescription}</p>}

      <FixedActionsBar centered stackOnMobile>
        <MtxButton className={styles.actionButton} variant="tertiary" size="large" fullWidth onClick={onExit}>
          <span>{t('qps.intro.back')}</span>
        </MtxButton>
        <MtxButton className={styles.actionButton} variant="primary" size="large" fullWidth onClick={onStart}>
          <span>{t('qps.intro.start')}</span>
        </MtxButton>
      </FixedActionsBar>
    </div>
  );
};

export default QpsIntroduction;
